import { all } from 'redux-saga/effects';

import authSagas from './auth';
import conferencingClientSagas from './client';
import qbSagas from './qb';
import reconnectSagas from './reconnect';
import videoRoomPluginSagas from './videoRoomPlugin';

export default function* rootSaga() {
  yield all([
    ...authSagas,
    ...conferencingClientSagas,
    ...qbSagas,
    ...reconnectSagas,
    ...videoRoomPluginSagas,
  ]);
}
